import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import theme from './LoadingContainer.scss';

class LoadingContainer extends Component {
  static propTypes = {
    focused: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };
  static defaultProps = {
    focused: false,
  };

  render() {
    const defaultBorder = classnames({
      [theme.focused]: this.props.focused,
    }, theme.default);

    const fakeContentClasses = classnames(theme.realContent, theme.pseudoReal);

    return (
      <div className={ theme.root }>
        <div className={ fakeContentClasses }>
          {this.props.children}
        </div>
        <div className={ theme.realContent }>
          {this.props.children}
        </div>
        <div className={ theme.borders }>
          <div className={ theme.borderContainer }>
            <div className={ defaultBorder } />
            <div className={ theme.notValid }>
              <div className={ theme.content } />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingContainer;
